export default {"src":"/_next/static/media/icone-potential.7329e452.svg","height":18,"width":32,"blurWidth":0,"blurHeight":0};